import { Card, CardContent } from "@/components/ui/card";
import { ClipboardList, Users, FileText, Shield } from "lucide-react";
import { useTranslation } from "react-i18next";

export const InfoCards = () => {
  const { t } = useTranslation();

  const cards = [
    {
      icon: <ClipboardList className="w-12 h-12 text-[#bc943e]" />,
      title: t("didYouKnow.cards.title.1"),
      text: t("didYouKnow.cards.1", { returnObjects: true }),
    },
    {
      icon: <Users className="w-12 h-12 text-[#bc943e]" />,
      title: t("didYouKnow.cards.title.2"),
      text: t("didYouKnow.cards.2", { returnObjects: true }),
    },
    {
      icon: <FileText className="w-12 h-12 text-[#bc943e]" />,
      title: t("didYouKnow.cards.title.3"),
      text: t("didYouKnow.cards.3", { returnObjects: true }),
    },
    {
      icon: <Shield className="w-12 h-12 text-[#bc943e]" />,
      title: t("didYouKnow.cards.title.4"),
      text: t("didYouKnow.cards.4", { returnObjects: true }),
    },
  ];

  return (
    <section className="py-16 bg-[#F7F7F7]">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-left mb-12 text-[#bc943e]">
          {t("didYouKnow.title")}
        </h2>
        <p className="text-gray-600 mb-4">
          {t("didYouKnow.content.1")}
        </p>
        <p className="text-gray-600 mb-4">
          {t("didYouKnow.content.2")}
        </p>
        <div className="grid md:grid-cols-4 gap-6">
          {cards.map((card, index) => (
            <Card key={index} className="text-center p-6 border-none shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="space-y-4">
                <div className="flex justify-center">{card.icon}</div>
                <h3 className="text-xl font-semibold mb-2 text-gray-800">{card.title}</h3>
                <p className="text-[#666666] text-left leading-relaxed whitespace-pre-line">
                  {card.text.map((line: string, idx: number) => (
                      <span key={idx} className="flex items-start mt-2">
                        <span className="mr-2 text-[#bc943e]">•</span>
                        {line}
                    </span>
                  ))}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};